import React, { useEffect, useState } from "react";
import axios from "axios";
import appConstants from "../constants/appConstants";
import { Modal, Button, Form } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaClipboardList } from "react-icons/fa";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";

const getAuthToken = () => localStorage.getItem("authToken");

const TermExamsPage = () => {
    const navigate = useNavigate();
  const [termExams, setTermExams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [batches, setBatches] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    batch_id: "",
    subjects: [],
  });
  const [showSubjectModal, setShowSubjectModal] = useState(false);
const [selectedExam, setSelectedExam] = useState(null);
const [selectedSubjectId, setSelectedSubjectId] = useState("");
const [loading, setLoading] = useState(false);
const [saving, setSaving] = useState(false);


  const fetchTermExams = async () => {
    setLoading(true);
    const token = getAuthToken();
    try {
      const res = await axios.get(`${appConstants.API_ROOT_URL}get-term-exams`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTermExams(res.data.data || []);
    } catch (err) {
      console.error("Error fetching term exams", err);
    }
    finally{
      setLoading(false);
    }
  };

  const fetchBatches = async () => {
    const token = getAuthToken();
    try {
      const res = await axios.get(`${appConstants.API_ROOT_URL}get-batches`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBatches(res.data.data || []);
    } catch (err) {
      console.error("Error fetching batches", err);
    }
  };

  const fetchSubjects = async () => {
    const token = getAuthToken();
    try {
      const res = await axios.get(`${appConstants.API_ROOT_URL}get-subjects`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubjects(res.data.data || []);
    } catch (err) {
      console.error("Error fetching subjects", err);
    }
  };

  useEffect(() => {
    fetchTermExams();
    fetchBatches();
    fetchSubjects();
  }, []);

  const openModal = (data = null) => {
    setEditData(data);
    setFormData(
        data
            ? {
                name: data.name,
                batch_id: data.batch_id,
                subjects: data.subjects.map((s) => s.id), // Extract just IDs
            }
            : {
                name: "",
                batch_id: "",
                subjects: [],
            }
        );

    setShowModal(true);
  };

  const handleDelete = async (id, name) => {
    setSaving(true);
    const confirmation = window.confirm(
        `Are you sure you want to delete the term exam "${name}"?\n\n⚠️ This will permanently delete all its marks and subject data. This action cannot be undone.`
    );

    if (!confirmation) return;

    const token = getAuthToken();

    try {
        const res = await axios.post(
        `${appConstants.API_ROOT_URL}delete-term-exam`,
        { term_exam_id: id },
        { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.status === "success") {
        fetchTermExams();
        } else {
        alert(res.data.message || "Failed to delete term exam.");
        }
    } catch (err) {
        console.error("Delete error:", err);
        alert("Error deleting term exam. Please try again.");
    }
    finally{
      setSaving(false);
    }
    };


  const handleSubmit = async () => {
    setSaving(true);
  const token = getAuthToken();

  const url = editData
    ? `${appConstants.API_ROOT_URL}update-term-exam`
    : `${appConstants.API_ROOT_URL}create-term-exam`;

  const payload = editData
    ? { ...formData, term_exam_id: editData.id }
    : formData;

  try {
    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.data.status === "success") {
      fetchTermExams();
      setShowModal(false);
    } else {
      alert(res.data.message || "Something went wrong.");
    }
  } catch (err) {
    console.error("Submit error:", err);

    if (err.response && err.response.data) {
      // Backend error response
      const message =
        err.response.data.message || "Server responded with an error.";
      alert(message);
    } else if (err.request) {
      // No response received
      alert("No response from server. Please check your internet connection.");
    } else {
      // Any other error
      alert("Unexpected error occurred. Please try again.");
    }
  }
  finally{
    setSaving(false);
  }
};



    const openExamMarksPage = (exam) => {
        setSelectedExam(exam);
        setSelectedSubjectId(""); // Reset subject selection
        setShowSubjectModal(true);
    };


  return (
    <Layout>
      {loading ? (
        <>
        <p>Loading...</p>
        </>
      ) : (
        <>
        <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>
          <FaClipboardList className="me-2" />
          Term Exams
        </h4>
        <Button variant="primary" onClick={() => openModal()}>
          <FaPlus className="me-2" />
          Create Term Exam
        </Button>
      </div>

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Name</th>
            <th>Batch</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {termExams.map((term) => (
            <tr key={term.id}>
              <td>{term.name}</td>
              <td>{term.batch_name}</td>
              <td>
                <Button
                  size="sm"
                  variant="warning"
                  className="me-2"
                  onClick={() => openModal(term)}
                >
                  <FaEdit /> Edit
                </Button>
                




                <Button
                    size="sm"
                    variant="info"
                    className="me-2"
                    onClick={() => {
                        openExamMarksPage(term);
                    }}
                    >
                    Enter Marks
                    </Button>



                    <Button
                      size="sm"
                      variant="secondary"
                      className="me-2"
                      onClick={() => navigate(`/term-exam-marks-view?term_exam_id=${term.id}&batch_id=${term.batch_id}`)}
                    >
                      View
                    </Button>





                    <Button
                        size="sm"
                        variant="danger"
                        onClick={() => handleDelete(term.id, term.name)}
                        disabled = {saving}
                        >
                          <FaTrash /> Delete
                        </Button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>




          <Modal show={showSubjectModal} onHide={() => setShowSubjectModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Select Subject</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form.Group>
      <Form.Label>Subject</Form.Label>
      <Form.Select
        value={selectedSubjectId}
        onChange={(e) => setSelectedSubjectId(e.target.value)}
      >
        <option value="">-- Select Subject --</option>
                {selectedExam?.subjects?.map((subject) => (
        <option key={subject.id} value={subject.id}>
            {subject.name}
        </option>
        ))}

      </Form.Select>
    </Form.Group>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowSubjectModal(false)}>
      Cancel
    </Button>
    <Button
      variant="primary"
      disabled={!selectedSubjectId}
      onClick={() => {
        setShowSubjectModal(false);
        navigate(
          `/exam-mark-entry?term_exam_id=${selectedExam.id}&subject_id=${selectedSubjectId}`
        );
      }}
    >
      Proceed to Mark Entry
    </Button>
  </Modal.Footer>
</Modal>





      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editData ? "Edit Term Exam" : "Create Term Exam"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Term Name</Form.Label>
              <Form.Control
                type="text"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Batch</Form.Label>
              <Form.Select
                value={formData.batch_id}
                onChange={(e) =>
                  setFormData({ ...formData, batch_id: e.target.value })
                }
              >
                <option value="">-- Select Batch --</option>
                {batches.map((batch) => (
                  <option key={batch.id} value={batch.id}>
                    {batch.class_name} {batch.division}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Subjects</Form.Label>
              <Form.Select
                multiple
                value={formData.subjects}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    subjects: Array.from(e.target.selectedOptions, (option) => option.value),
                  })
                }
              >
                {subjects.map((subj) => (
                  <option key={subj.id} value={subj.id}>
                    {subj.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={saving}>
            {saving ? (
              <>
              Saving...
              </>
            ) : (
              <>
              {editData ? "Update" : "Create"}
              </>
            )}
            
            </Button>

        </Modal.Footer>
      </Modal>
        </>
      )}
      
    </Layout>
  );
};

export default TermExamsPage;
